/* eslint-disable camelcase */
import { API } from "./API";

export const getK3Scripts = (query) => {
  var {
    id,
    scriptId,
    scriptIds,
    keyword,
    sort_by = 'updatedAt',
    sort_order = 'desc',
    language,
    execution_target,
    script_type,
    is_template,
    limit = 20,
    page = 1
  } = query;

  var queryStr = `sort_by=${sort_by}&sort_order=${sort_order}`;

  if (id)
    queryStr += `&id=${id}`;

  if (scriptId)
    queryStr += `&script_id=${scriptId}`;

  if (scriptIds)
    queryStr += `&script_ids=${scriptIds}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  if (language)
    queryStr += `&language=${language}`;

  if (execution_target)
    queryStr += `&execution_target=${execution_target}`;

  if (script_type)
    queryStr += `&script_type=${script_type}`;

  if (is_template !== undefined)
    queryStr += `&is_template=${is_template}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  if (page)
    queryStr += `&page=${page}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/k3script?${queryStr}`);
}

export const setK3Scripts = (scripts, query = {}) => {
  var { generate_version = false } = query;

  var queryStr = `generate_version=${generate_version}`;

  return API.post(`${process.env.REACT_APP_API_URL}/api/k3script?${queryStr}`, scripts);
}

export const k3scriptService = {
  getK3Scripts,
  setK3Scripts
} 